import React, { useState } from 'react'
import "./insightPaginationStyle.scss";


const PreviousBtn = ({ current, handlePageChange }) => {
  return (
    <div className="pre-icon-container" > 
      <div className='prev-img-icon' onClick={() => handlePageChange(current - 1)}>
      </div>
    </div>
  );
}

//Pagination next link
const NextBtn = ({handlePageChange,current}) => {
  return (
    <div className="next-icon-container">
      <div className='next-img-icon' onClick={() => handlePageChange(current + 1)}>
      </div>
    </div>
  );
}
function AppPagination(props) {
  const { current, pages, handlePageChange } = props;
  return (
    <div className="pagination d-flex justify-content-between align-items-center">
      {current > 1 ? (
        <PreviousBtn {...props} /> 
      ): (
        <div className='prev-disable-btn'></div>
      )
    }
    
      {Array(pages).fill('-').map((_, i) => {
        return current === i + 1 ? (<span key={i} aria-current="page" className="active-page">{i + 1}</span>) : (
          <div key={i}  className="pageno" onClick={() => handlePageChange(i + 1)} to={() => false}>{i + 1}</div>
        )
      })}
      {current < pages ? (
        <NextBtn {...props} />
      ):(
        <div className='next-disable-btn'></div>
      )
    }

    </div>
  )
}

export default React.memo(AppPagination);